import { handleActions } from 'redux-actions';

export default handleActions(
	{
		UPDATE_AUTH_FIELD: (state, action) => ({
			...state,

			[action.payload.type]: {
				...state[action.payload.type],
				[action.payload.key]: action.payload.value,
			},
		}),

		UPDATE_ACCESS_TOKEN: (state, action) => ({
			...state,
			token: action.payload.token,
			status: action.payload.status,
			message: action.payload.message,
		}),

		LOAD_CONFIG: (state, action) => ({
			...state,
			token: action.payload.token,
		}),

		LOGOUT_FULFILLED: state => ({
			...state,

			token: {
				accessToken: '',
				endAt: '',
				expiresIn: '',
				refreshToken: '',
			},

			status: 0,
			message: '',
		}),
	},
	{
		loginForm: {
			email: { value: '' },
			password: { value: '' },
			remember: { value: false },
		},

		signupForm: {
			email: { value: '' },
			password: { value: '' },
			checkPassword: { value: '' },
			agreement: { value: false },
		},

		forgetForm: {
			email: { value: '' },
		},

		passwordForm: {
			password: { value: '' },
			checkPassword: { value: '' },
		},

		token: {
			accessToken: '',
			endAt: '',
			expiresIn: '',
			refreshToken: '',
		},

		status: 0,
		message: '',
	},
);



// WEBPACK FOOTER //
// ./src/reducers/auth.js